import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "proceso",
  class: "grain relative scroll-mt-20 overflow-hidden bg-char py-28 md:py-36"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute -right-40 top-1/3 h-[500px] w-[500px] rounded-full bg-ember/10 blur-3xl" }, null, -1)
const _hoisted_3 = { class: "mx-auto max-w-2xl text-center" }
const _hoisted_4 = { class: "eyebrow" }
const _hoisted_5 = { class: "section-title mt-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-molten" }, "obra maestra", -1)
const _hoisted_7 = { class: "mt-6 text-ivory/50" }
const _hoisted_8 = { class: "absolute left-7 top-0 h-full w-px bg-copper/15 md:left-0 md:top-7 md:h-px md:w-full" }
const _hoisted_9 = { class: "relative grid gap-12 md:grid-cols-4 md:gap-8" }
const _hoisted_10 = { class: "font-display text-2xl font-semibold text-ivory" }
const _hoisted_11 = { class: "mt-3 text-sm leading-relaxed text-ivory/50" }

import { onBeforeUnmount, onMounted, ref } from "vue";
import ContainerComponent from "@/components/base/ContainerComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcessComponent',
  setup(__props) {

const steps = [
  {
    title: "Diseño",
    text: "Escuchamos tu idea y la convertimos en boceto o modelo 3D listo para producción.",
  },
  {
    title: "Molde",
    text: "Creamos el modelo y el molde que capturan cada detalle de la pieza.",
  },
  {
    title: "Fundición",
    text: "Vaciamos el metal fundido con precisión para dar vida a la forma.",
  },
  {
    title: "Acabado",
    text: "Pulido, pátina, grabado y control de calidad antes de la entrega.",
  },
];

const timeline = ref<HTMLElement | null>(null);
const progress = ref(0);
const isDesktop = ref(false);

const update = () => {
  if (!timeline.value) return;
  isDesktop.value = window.innerWidth >= 768;
  const rect = timeline.value.getBoundingClientRect();
  const vh = window.innerHeight;
  // 0 cuando la línea de tiempo está al 85% del viewport, 1 cuando llega al 30%
  const start = vh * 0.85;
  const end = vh * 0.3 - (isDesktop.value ? 0 : rect.height * 0.7);
  progress.value = Math.min(1, Math.max(0, (start - rect.top) / (start - end)));
};

onMounted(() => {
  update();
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
});
onBeforeUnmount(() => {
  window.removeEventListener("scroll", update);
  window.removeEventListener("resize", update);
});

return (_ctx: any,_cache: any) => {
  const _directive_reveal = _resolveDirective("reveal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(ContainerComponent, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createTextVNode("Cómo trabajamos")
          ])), [
            [_directive_reveal]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_5, [
            _createTextVNode(" Del fuego a la "),
            _hoisted_6
          ])), [
            [_directive_reveal, 100]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, [
            _createTextVNode(" Cada pieza pasa por las manos de nuestros artesanos en un proceso cuidado de principio a fin. ")
          ])), [
            [_directive_reveal, 200]
          ])
        ]),
        _createElementVNode("div", {
          ref_key: "timeline",
          ref: timeline,
          class: "relative mt-20"
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "h-full w-full origin-top bg-gradient-to-b from-copper-light via-copper to-ember shadow-[0_0_14px_rgba(255,122,47,0.8)] md:origin-left md:bg-gradient-to-r",
              style: _normalizeStyle({
              transform: isDesktop.value
                ? `scaleX(${progress.value})`
                : `scaleY(${progress.value})`,
            })
            }, null, 4)
          ]),
          _createElementVNode("ol", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, i) => {
              return _withDirectives(_createElementVNode("li", {
                key: step.title,
                class: "relative pl-20 md:pl-0 md:pt-20"
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["absolute left-0 top-0 flex h-14 w-14 items-center justify-center rounded-full border font-display text-lg font-bold transition-all duration-500", 
                progress.value >= (i + 0.5) / steps.length
                  ? 'border-copper bg-gradient-to-br from-copper-light to-ember text-ink shadow-[0_0_30px_rgba(255,122,47,0.7)]'
                  : 'border-copper/30 bg-ink text-copper'
              ])
                }, _toDisplayString(i + 1), 3),
                _createElementVNode("h3", _hoisted_10, _toDisplayString(step.title), 1),
                _createElementVNode("p", _hoisted_11, _toDisplayString(step.text), 1)
              ]), [
                [_directive_reveal, i * 150]
              ])
            }), 64))
          ])
        ], 512)
      ]),
      _: 1
    })
  ]))
}
}

})